import { Box, Container, Flex, Heading, Text } from '@chakra-ui/react';
import Image from 'next/image';
import RichTextContent from 'components/common/RichText';
import { Storyblok } from 'types';

type AuthorContentProps = {
  name: string;
  position: string;
  picture: {
    filename: string;
    alt: string;
  };
  text: Storyblok.RichText;
};

const AuthorContent = ({ name, position, picture, text }: AuthorContentProps) => {
  return (
    <Box>
      <Container
        as="section"
        background="url('/assets/hero-bg.jpg') right no-repeat"
        backgroundSize="cover"
        marginY="20px"
        maxWidth="100%"
        width="100%"
      >
        <Container height={0} display="flex" alignItems="center">
          <Flex
            gap={{ base: '16px', desktop: '24px' }}
            flexDirection={{ base: 'column', desktop: 'row' }}
            alignItems="center"
          >
            <Box position="relative" boxSize={{ base: '100px', desktop: '200px' }} rounded="4px" overflow="hidden">
              <Image src={picture.filename} alt={picture.alt} layout="fill" objectFit="cover" objectPosition="top" />
            </Box>
            <Flex
              flexDirection="column"
              alignItems={{ base: 'center', desktop: 'flex-start' }}
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              <Heading as="h1" size="xl" mb={{ base: '8px', desktop: '24px' }}>
                {name}
              </Heading>
              <Text>{position}</Text>
            </Flex>
          </Flex>
        </Container>
      </Container>
      <Container>
        <RichTextContent content={text} />
      </Container>
    </Box>
  );
};

export default AuthorContent;
